import { useContext, useEffect } from "react";
import { RankingContext } from "@/context/ranking";
import { makeArray } from "../../../../../utils/factorys";
import { FlowersProps, PetalPropsData } from "../../interfaces";
import { Petal } from "../petal";
import { TooltipContainer } from "../tooltip";
import { FlowerContainer } from "./style";
import Tooltip from '@mui/material/Tooltip';
import { styled } from "@mui/material/styles";



export const Flower: React.FC<FlowersProps> = ({ petalsData, value, isMobile }) => {

  const BlueOnGreenTooltip = styled(({ className, ...props }: any) => (
    <Tooltip  {...props} componentsProps={{ tooltip: { className } }} />
  ))(`
      background: transparent;
      font-size: 1.5em;
  `);

  const colors = ['rgb(22 133 158)', 'rgb(72 170 138)', 'rgb(254 211 82)', 'rgb(227 76 112)', 'rgb(148 16 89)', '#D73137', '#8CB747', '#38A7DF', '#F78D12', 'rgb(80 82 81)'];

  const { researchArea, Indicadores } = useContext(RankingContext);

  let deg = 0;

  const arrData = makeArray(petalsData);

  const color = Indicadores[researchArea]?.color;

  function compare(a: any, b: any) {
    if (a.sigla < b.sigla) {
      return -1;
    }
    if (a.sigla > b.sigla) {
      return 1;
    }
    return 0;
  }

  arrData.sort(compare);
 
  return (
    <BlueOnGreenTooltip  title={<TooltipContainer stateInfo={value} data={arrData} />}>
      <FlowerContainer>
        {arrData.map((e: PetalPropsData, index: number) => {
          if (index > 0) {
            deg += 36;
          }
          if (researchArea !== 'Geral') {
            if (e.sigla === researchArea) {

              return (<Petal isMobile={isMobile} key={index} degrees={deg} color={color} stroke heigth={e.indice} />)
            }
            return (<Petal isMobile={isMobile} key={index} degrees={deg} heigth={e.indice} />)
          }
          return (<Petal isMobile={isMobile} key={index} degrees={deg} color={colors[index]} heigth={e.indice} />)
        })}
      </FlowerContainer>
    </BlueOnGreenTooltip>
  );
};
